import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { Avatar } from "@opensea/next-ui-kit";
import { Flex, Pill } from "@opensea/ui-kit";
export function ChainSearchPill(t0) {
  const $ = _c(17);
  let chain;
  let rest;
  if ($[0] !== t0) {
    ({
      chain,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = chain;
    $[2] = rest;
  } else {
    chain = $[1];
    rest = $[2];
  }
  const {
    getLogo,
    getChainName
  } = useChains();
  let t1;
  if ($[3] !== chain || $[4] !== getLogo) {
    t1 = getLogo(chain, {
      circle: true,
      monochrome: true
    });
    $[3] = chain;
    $[4] = getLogo;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <Avatar size={11} {...t1} />;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== chain || $[9] !== getChainName) {
    t3 = getChainName(chain);
    $[8] = chain;
    $[9] = getChainName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <Flex className="items-center gap-1.5">{t2}{t3}</Flex>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== rest || $[15] !== t4) {
    t5 = <Pill {...rest}>{t4}</Pill>;
    $[14] = rest;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}